import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { WhatsAppTemplate } from '@/src/infrastructure/Protocol/Inbox/IInboxService';

import { TemplateKey, TwilioMediaTemplate } from '@/modules/CampaignsModule/interfaces/WhatsApp';
import { atomWhatsAppTemplates } from '@/modules/ContactsModule/atoms/WhatsApp';

interface UseFilteredTemplatesParams {
  filterBy?: 'pending' | 'approved' | 'rejected';
  searchTerm?: string;
}

export const useFilteredTemplates = ({ filterBy, searchTerm = '' }: UseFilteredTemplatesParams) => {
  const templates = useAtomValue(atomWhatsAppTemplates);

  const getTemplateContent = (template: WhatsAppTemplate) => {
    const templateType = Object.keys(template.types)[0] as TemplateKey;
    const templateData = template.types[templateType];

    if (!templateData) return '';

    switch (templateType) {
      case 'twilio/media': {
        return `${templateData.body} ${(templateData as TwilioMediaTemplate).media.join(' ')}`;
      }
      case 'twilio/text':
        return templateData.body;
      default:
        return '';
    }
  };

  const filteredTemplates = useMemo(() => {
    let filtered = [...templates];

    if (filterBy) {
      filtered = filtered.filter(
        (template) => template.approvalStatus?.toLowerCase() === filterBy.toLowerCase()
      );
    }

    if (searchTerm) {
      filtered = filtered.filter((template) => {
        const searchIn = `${template.friendly_name} ${getTemplateContent(template)} ${
          template.sid
        }`.toLowerCase();
        return searchIn.includes(searchTerm.toLowerCase());
      });
    }

    return filtered;
  }, [templates, filterBy, searchTerm]);

  return { filteredTemplates };
};
